<template>
  <section class="section pb-0 section-components">
    <div class="py-5 bg-secondary">
      <div class="container">
        <h2 class="mb-3">
          <span>TUHG APES mint</span>
        </h2>
        <!-- <p>
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. The point of
          using Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English. Many desktop publishing packages and web
          page editors now use Lorem Ipsum as their default model text, and a
          search for 'lorem ipsum' will uncover many web sites still in their
          infancy. Various versions have evolved over the years, sometimes by
          accident, sometimes on purpose (injected humour and the like).
        </p> -->
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <card shadow class="h-100">
              <h3>
                Mint Date <br /><br />
                <h5>Oct 30 2021 10:00:00 UTC</h5>
              </h3>
            </card>
          </div>
          <div class="col-lg-4 col-sm-6">
            <card shadow>
              <h3>
                Total Mints <br /><br />
                <h2>5,555</h2>
              </h3>
            </card>
          </div>
          <div class="col-lg-4 col-sm-6">
            <card shadow>
              <h3>
                Price per Pre Mint <br /><br />
                <h2>0.1 SOL</h2>
              </h3>
            </card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style>
</style>
